<!-- Spacer -->
<div
    class="hippo-vertical-navigation-item-wrapper"
    [ngClass]="$safeNavigationMigration(item.classes?.wrapper)"></div>
